import { Transition, Dialog } from "@headlessui/react"
import { ChipIcon, QuestionMarkCircleIcon, ReplyIcon, SearchIcon, TerminalIcon } from "@heroicons/react/outline";
import { useStoreActions, useStoreState } from "easy-peasy";
import { Fragment, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import "./styles.scss";

const functions = [
  {
    group: 'navigation',
    action: 'navigate',
    destination: '/digitalworkers/create?fromAI=1',
    label: 'Create a worker',
    endpoint: '',
    required: true,
    icon: TerminalIcon
  },
  {
    group: 'navigation',
    action: 'navigate',
    destination: '/integrations?fromAI=1',
    label: 'Create an integration',
    endpoint: '',
    required: false,
    icon: ChipIcon,
  },
  {
    group: 'dialog',
    action: 'open_dialog',
    dialog: 'qaDialog',
    label: 'Q & A',
    endpoint: '',
    icon: QuestionMarkCircleIcon
  }
];

export function AIDialog({ open, setOpen, setQADialogOpen }) {
  const history = useHistory();

  const query = useStoreState((state) => state.ai.query);
  const setQuery = useStoreActions((actions) => actions.ai.setQuery);
  const setOpenAICreateWorkerDialogOpen = useStoreActions((actions) => actions.openAICreateWorkerDialog.setOpen);

  const inputRef = useRef(null);

  const groups = functions.reduce((groups, item) => {
    return { ...groups, [item.group]: [...(groups[item.group] || []), item] };
  }, {})

  useEffect(() => {
    if (open) {
      setQuery('');
    }
  }, [open]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {
        setOpen(false);
      }}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto p-3">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="mx-auto max-w-3xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all">
              <div className="relative">
                <SearchIcon
                  className="pointer-events-none absolute left-4 top-3 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                <div
                  ref={inputRef}
                  style={{
                    width: '100%',
                    height: 'max-content',
                    padding: '0.5rem 0.5rem 0.5rem 2.5rem',
                    outline: 'none',
                    border: '1px solid transparent',
                    borderRadius: '0.725rem',
                    fontSize: '0.875rem',
                    lineHeight: '1.5rem',
                  }}
                  placeholder="Get started with Xpertly Assistant"
                  // className="w-full border-0 bg-transparent pl-11 pr-4 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
                  contentEditable={true}
                />
              </div>
                    
              { Object.entries(groups).map(([group, items]) => (
                <div key={group}>
                  <h2 className="bg-gray-100 px-4 py-2.5 text-xs font-semibold text-gray-900 uppercase">{group}</h2>
                  <ul className="text-sm text-gray-800">
                    { location.pathname == '/digitalworkers/create' && group === 'navigation' && (
                      <li
                        role="none"
                        onClick={() => {
                          setOpen(false);
                          setOpenAICreateWorkerDialogOpen(true);
                        }}
                      >
                        <ul className="text-sm text-gray-700" role="none">
                          <li className="flex cursor-default select-none items-center rounded-md px-3 py-2 hover:bg-sky-600 hover:text-white" id="headlessui-combobox-option-5" role="option" aria-selected="false" data-headlessui-state="">
                            <ReplyIcon className="h-5 w-5" />
                            <span className="ml-3 flex-auto truncate">Modify the worker</span>
                          </li>
                        </ul>
                      </li>
                    )}
                    {items.map((func, index) => (
                      <li
                        key={index}
                        className='flex cursor-default select-none items-center rounded-md px-3 p-2 hover:bg-sky-600 hover:text-white'
                        onClick={() => {
                          const content = inputRef.current.textContent;
                          if (func.action === 'navigate') {
                            if (func.required && (content === '' || !content)) {
                              alert('The query is required.');
                              return false;
                            }
                            setQuery(content);
                            history.push(func.destination);
                          } else if (func.action === 'open_dialog') {
                            setQuery(content);
                            setOpen(false);
                            setQADialogOpen(true);
                          }
                        }}
                      >
                        <>
                          <func.icon
                            className='h-5 w-5 flex-none hover:text-white'
                            aria-hidden="true"
                          />
                          <span className="ml-3 flex-auto truncate">{func.label}</span>
                        </>
                      </li>
                    ))}
                  </ul>
                </div>
              )) }
              {/* available functions */}
                {/* <ul className="text-sm text-gray-700 p-2">
                  { location.pathname == '/digitalworkers/create' && (
                    <li
                      role="none"
                      onClick={() => {
                        setOpen(false);
                        setOpenAICreateWorkerDialogOpen(true);
                      }}
                    >
                      <ul className="text-sm text-gray-700" role="none">
                        <li className="flex cursor-default select-none items-center rounded-md px-3 py-2 hover:bg-sky-600 hover:text-white" id="headlessui-combobox-option-5" role="option" aria-selected="false" data-headlessui-state="">
                          <ReplyIcon className="h-5 w-5" />
                          <span className="ml-3 flex-auto truncate">Modify the worker</span>
                        </li>
                      </ul>
                    </li>
                  )}
                  {functions.map((func, index) => (
                    <li
                      key={index}
                      className='flex cursor-default select-none items-center rounded-md px-3 p-2 hover:bg-sky-600 hover:text-white'
                      onClick={() => {
                        const content = inputRef.current.textContent;
                        if (func.action === 'navigate') {
                          if (content === '' || !content) {
                            alert('The query is required.');
                            return false;
                          }
                          setQuery(content);
                          history.push('/digitalworkers/create?fromAI=1');
                        } else if (func.action === 'open_dialog') {
                          setQuery(content);
                          setOpen(false);
                          setQADialogOpen(true);
                        }
                      }}
                    >
                      <>
                        <func.icon
                          className='h-5 w-5 flex-none hover:text-white'
                          aria-hidden="true"
                        />
                        <span className="ml-3 flex-auto truncate">{func.label}</span>
                      </>
                    </li>
                  ))}
                </ul> */}

            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};